export const DEV_PANEL_HOSTNAMES: readonly string[] = [
  'local.pop.store',
  'dev.pop.store',
  'localhost',
];

/**
 * The simulator renders the app inside its own iframe, so a framed copy must
 * never mount a second panel.
 */
export function isDevPanelHost(
  hostname: string,
  isTopWindow: boolean,
): boolean {
  return isTopWindow && DEV_PANEL_HOSTNAMES.includes(hostname);
}
